import React from "react";
import SubTitle from "../../elements/SubTitle";

const jQuery = require( 'jquery' );
const $ = jQuery;
window.jQuery = jQuery;

require('jvectormap');
require('../vendor/jquery-jvectormap-nz-mill-en.js');

class RegionSelect extends React.Component {

    drawMap(){
         $('#nz-map').vectorMap({
            map: 'nz_mill',
            panOnDrag: false,
            zoomOnScroll: false,
            zoomButtons: false,
            backgroundColor: 'transparent',
            onRegionOver: function (e, code) {
                $(this).on('click', function () {
                    var map = $('#nz-map').vectorMap('get', 'mapObject');
                    var name = map.getRegionName(code);
                    //ADDED ALERT TO SHOW NAME OF CLICKED COUNTRY

                    name = name.toLowerCase()
                    name = name.replace(/ /g, '-')
                    name = name.replace(/[^\w-]+/g, '')
                    window.location.href = "/regions/" + name
                });
            },
            onRegionOut: function (e, code) {
                $(this).unbind('click');
            },
            onRegionClick: function (event, code) {

                //
                var map = $('#nz-map').vectorMap('get', 'mapObject');
                var name = map.getRegionName(code);
                //ADDED ALERT TO SHOW NAME OF CLICKED COUNTRY

                name = name.toLowerCase()
                name = name.replace(/ /g, '-')
                name = name.replace(/[^\w-]+/g, '')


                window.location.href = "/regions/" + name
            },
            focusOn: {
                x: 0.2,
                y: 0.7,
                scale: 3
            },
            series: {
                regions: [{
                    scale: {

                        'Southern Region': '#22a0af',
                        'Canterbury Region': '#d41e47',
                        'Midcentral Region': '#59753b',
                        'Midland Region': '#71c167',
                        'Capital and Coast Region': '#f6ac1e',
                        'Auckland and Northland Region': '#378aca'
                    },
                    attribute: 'fill',
                    values: {
                        "NZ-NSN": "Canterbury Region",
                        "NZ-STL": "Southern Region",
                        "NZ-HKB": "Midcentral Region",
                        "NZ-BOP": "Midland Region",
                        "NZ-AUK": "Auckland and Northland Region",
                        "NZ-TKI": "Midcentral Region",
                        "NZ-MBH": "Canterbury Region",
                        "NZ-TAS": "Canterbury Region",
                        "NZ-WKO": "Midland Region",
                        "NZ-WTC": "Canterbury Region",
                        "NZ-OTA": "Southern Region",
                        "NZ-NTL": "Auckland and Northland Region",
                        "NZ-MWT": "Midcentral Region",
                        "NZ-WGN": "Capital and Coast Region",
                        "NZ-GIS": "Midland Region",
                        "NZ-CAN": "Canterbury Region"
                    }
                }]
            },
            regionStyle: {

                hover: {
                    "fill-opacity": 0.8
                }
            }
        })
    }
    componentDidMount() {
        this.drawMap();
    }


    render() {

        let title;
        if(this.props.title) {
            title =   <SubTitle title={this.props.title} direction="right" />;
        }else{
            title = '';
        }



        return (
          <section className={"rob-regions"}>

              <div className="rob-regions__map" >
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div id="nz-map" className={"rob-regions__map-images"}>

                            </div>
                        </div>
                        <div className="col-md-6 rob-regions__col">
                            {title}
                            <div className="container rob-regions__description">
                                <div  dangerouslySetInnerHTML={{__html: this.props.paragraph}}  >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </section>
        )
    }
}

export default RegionSelect;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/RegionSelect.js